import React, { useState, useMemo, useEffect } from "react";
import Modal from "../Modal";
import styled from '@emotion/styled';
import { Alert } from "../Alert";
import { isMobile } from 'react-device-detect';
import { StyledModal } from "../../StyledComponents/Modals/Modals";
import Card from "../Card";

const ModalFooter = styled.div`
  text-align: right;
  flex-shrink: 0;
  padding: 10px 0px;
`;

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${isMobile ? '300px' : '500px'};
  border-radius: 8px;
  overflow: hidden;
  background: #000;
  
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const Button = styled.button`
  background-color: #93C572;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  padding: 10px 20px;
  margin-right: 10px;

  &:hover {
    background-color: #698D51;
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

export default function TutorialsModal({
    showHideModal,
    isModalOpen,
    colour,
    selectedTutorial,
}) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    return (
        <Modal open={isModalOpen}>
            <StyledModal>
                <Card label={selectedTutorial.tutorial_name} headercolour={colour.sidebar} headerTextColour={colour.font}>
                    <VideoContainer
                        dangerouslySetInnerHTML={{ __html: selectedTutorial.tutorial_link }}
                    />
                    <ModalFooter>
                        {isLoading && <Alert type='information'>Loading..</Alert>}
                        <Button onClick={() => showHideModal(null)}>Close</Button>
                    </ModalFooter>
                </Card>
            </StyledModal>
        </Modal>
    );
}
